import React from 'react';
export var PortalContext = /*#__PURE__*/React.createContext([]);